import { useEffect, useState } from "react";
import { MEDIA_QUERIES } from "config/theme/breakpoints";

function getSnapshot() {
  if (typeof window === "undefined") {
    return { isMobile: false, isDesktop: true };
  }
  const isMobile = window.matchMedia(MEDIA_QUERIES.mobile).matches;
  return { isMobile, isDesktop: !isMobile };
}

export default function useBreakpoint() {
  const [state, setState] = useState(getSnapshot);

  useEffect(() => {
    const mql = window.matchMedia(MEDIA_QUERIES.mobile);
    const handleChange = () => setState(getSnapshot());

    handleChange();
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, []);

  return state;
}
